export const styles = {
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    gap: 3.25,
  },
};
